/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum WorkFlowLifeCycleStatus {
    Data_Generated = 'Data Generated',
    Waiting_For_Approval = 'Waiting For Approval',
    Approval_Process_Completed = 'Approval Process Completed',
    Approval_Process_Failed = 'Approval Process Failed',
    Rejection_Process_Completed = 'Rejection Process Completed',
    Rejection_Process_Failed = 'Rejection Process Failed',
    WorkFlow_Completed = 'WorkFlow Completed',
    Resource_Realized = 'Resource Realized'
}
